import React, { useEffect, useState, useRef } from "react"
import settings from "settings"
import * as mapboxgl from "mapbox-gl"
import "mapbox-gl/dist/mapbox-gl.css"
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder"
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css"
import classNames from "classnames"

//? Props to pass in are height, onClick if you don't want to auto-post to formik, formik if you want it to auto update values.  Triggerwipe is used to get rid of all the markers...on the parent just flip state to trigger.  See the areaFeatures component for implementation.

const LatLngPicker = (props) => {
	const regularStyle = settings.customMapStyle || "mapbox://styles/mapbox/streets-v11"
	const mapContainer = useRef(null)
	const [mapType, setMapType] = useState("mapbox://styles/mapbox/satellite-streets-v11")
	const [map, setMap] = useState(null)
	const [lng, setLng] = useState(false)
	const [lat, setLat] = useState(false)
	const [zoom, setZoom] = useState(15)
	const [coords, setCoords] = useState({})
	const [markers, setMarkers] = useState([])
	const markersRef = useRef(markers)

	useEffect(() => {
		initMap()
	}, [])

	useEffect(() => {
		if(props.triggerWipe) {
			wipeMarkers()
		}
	}, [props.triggerWipe])

	useEffect(() => {
		initMap()
	}, [mapType])

	const _setMarkers = (data) => {
		markersRef.current = data
		setMarkers(data)
	}

	const placeMarker = (map, coords) => {
		let marks = [...markersRef.current]
		marks.forEach((marker) => {
			marker.remove()
		})
		let marker = new mapboxgl.Marker().setLngLat(coords).addTo(map)
		_setMarkers([marker])
	}

	const initMap = () => {
		let center = [lng, lat]
		if (props.data && props.data.lat && props.data.lng) {
			// existing map, place marker
			center = [props.data.lng, props.data.lat]
		} 
		else if(props?.coords && props.coords.length > 0) {
			center = props.coords
		}
		else if (!lat && !lng) {
			let property = _.find(props.payload.public.properties, { id: props.activeProperties[0] })
			center = [property.lng, property.lat]
		}
		const map = new mapboxgl.Map({
			accessToken: settings.mapboxKeySpecial || settings.mapboxKey,
			container: mapContainer.current,
			style: mapType,
			center,
			pitch: 15,
			zoom,
			minZoom: 10,
			maxZoom: 18,
			attributionControl: false,
		})

		// Add navigation control (the +/- zoom buttons)
		map.addControl(new mapboxgl.NavigationControl(), "bottom-right")
		map.addControl(
			new MapboxGeocoder({
				accessToken: settings.mapboxKeySpecial || settings.mapboxKey,
				mapboxgl: mapboxgl,
			})
		)
		map.getCanvas().style.cursor = "pointer"

		map.on("click", (e) => {
			if (props.onClick) props.onClick(e.lngLat)
			setCoords(e.lngLat)
			if (props.formik) {
				props.formik.setFieldValue("lat", e.lngLat.lat)
				props.formik.setFieldValue("lng", e.lngLat.lng)
			}
			// React and Mapbox dont' play well, so this accesses the ref to state and modifies
			placeMarker(map, e.lngLat)
		})

		map.on("move", () => {
			setLng(map.getCenter().lng.toFixed(4))
			setLat(map.getCenter().lat.toFixed(4))
			setZoom(map.getZoom().toFixed(2))
		})
		map.on("load", async () => {
			// Existing map, place marker
			try {
				if (props.data && props.data.lat && props.data.lng) {
					placeMarker(map, { lng: props.data.lng, lat: props.data.lat })
				} else if (props?.coords) {
					placeMarker(map, {
						lng: props.coords[0],
						lat: props.coords[1],
					})
				}
			} catch (e) {
				console.log(e)
			}
			if(props?.property?.section_geo) {
				map.addSource("section", {
					type: "geojson",
					data: props.property.section_geo,	
				})
				map.addLayer({
					id: "section",
					type: "fill",
					source: "section",
					paint: {
						"fill-color": "#86c928",
						"fill-opacity": 0.5,
					},
				})
			}
			props.loadingStatus(false)
			setMap(map)
		})
		//map.scrollZoom.disable()
		// Clean up on unmount
		return () => map.remove()
	}

	const wipeMarkers = () => {
		let marks = [...markersRef.current]
		marks.forEach((marker) => {
			marker.remove()
		})
		_setMarkers([])
	}

	return (
		<div>
			<ul className="flex justify-end">
				<li
					className={classNames(`border border-blue bg-white text-blue px-4 py-2 text-sm cursor-pointer`, {
						"bg-blue !text-white": mapType == regularStyle,
					})}
					onClick={() => setMapType(regularStyle)}>
					Street
				</li>
				<li
					className={classNames(`border border-blue bg-white text-blue px-4 py-2 text-sm cursor-pointer`, {
						"bg-blue !text-white": mapType == "mapbox://styles/mapbox/satellite-streets-v11",
					})}
					onClick={() => setMapType("mapbox://styles/mapbox/satellite-streets-v11")}>
					Satellite
				</li>
			</ul>
			<div className="LatLngPicker" ref={mapContainer} style={{ height: `${props.height}px` }} />
		</div>
	)
}

export default LatLngPicker
